export const configuration = {
    host: 'https://server.8aevents.com/api',
    mainHost: 'https://www.8aevents.com'
}